import '../../../js/core.js'
import 'sticky-kit/dist/sticky-kit'
import '../../../js/scroll-to-anchor.js'
import '../../../js/bottom-banner.js'
import '../../../js/sticky-sidebar.js'
import '../../../js/progress-bar.js'
import '../../../js/switcher.js'
import '../../../js/video-youtube-iframe.js'
import '../../../js/contact-form.js'
import './single-blog.less';

$(function () {
  import('owl.carousel/src/js/owl.carousel').then(() => {
    import('owl.carousel/src/js/owl.navigation').then(() => {
      jQuery('.js-articles-carousel').owlCarousel({
        responsive: {
          0: { items: 1 }, 768: { items: 2 }, 1211: { items: 3 }
        },
        margin: 20,
        nav: true,
        loop: true,
        dots: true,
        items: 1
      });
    });
  })
});

$(function () {
  import('owl.carousel/src/js/owl.carousel').then(() => {
    import('owl.carousel/src/js/owl.navigation').then(() => {
      import('owl.carousel/src/js/owl.lazyload').then(() => {
        jQuery('.js-single-articles-carousel').owlCarousel({
          nav: true,
          loop: true,
          dots: true,
          margin: 24,
          items: 1,
          slideBy: 1
        });
      });
    });
  })
});

$(function () {
  var trigger = $('.wrapper-video .video-container');
  let playButton = $('.wrapper-video .video-button');
  let control = $('.wrapper-video .video').prop("controls", false);
  trigger.on('click', function () {
    playButton.hide();
    control.prop("controls", true);
  });
});




function ShowTooltip() {


  $(".reference").each(function (index) {
    var thisReference = $(this);
    var tooltipItem = thisReference.find('.tooltip-ref');
    var windowWidth = $(window).width();

    tooltipItem.css('transform', "none");

    var contentOffsetLeft = Math.round($('.block-section').offset().left);
    var tooltipOffsetLeft = Math.round(tooltipItem.offset().left);
    var contentOffsetRight = windowWidth - (contentOffsetLeft + $('.block-section').outerWidth());
    var tooltipOffsetRight = windowWidth - (tooltipOffsetLeft + tooltipItem.outerWidth());

    

    if (tooltipOffsetLeft < contentOffsetLeft) {
      tooltipItem.css('transform', "translateX(" + (contentOffsetLeft - tooltipOffsetLeft) + "px)");
    }

    if (tooltipOffsetRight < contentOffsetRight) {
      tooltipItem.css('transform', "translateX(" + -1 * (contentOffsetRight - tooltipOffsetRight) + "px)");
    }


    thisReference.on('mouseover', function () {
      $(this).addClass('active');
    });
    thisReference.on('mouseout', function () {
      $(this).removeClass('active');
    });

    thisReference.find('.close').on('click', function () {
      thisReference.removeClass('active');
    });
  });
}

$('.reference .js-scroll-nav').on('click', function () {
  var hash = $(location).attr('hash');

  $('.block-section footer li').removeClass('active');
  $(hash).addClass('active');
});

$('.block-section footer .js-scroll-nav').on('click', function () {
  $('.block-section footer li').removeClass('active');
});

window.addEventListener('DOMContentLoaded', function(){
  ShowTooltip();
});

$(document).on('ready', function () {
  ShowTooltip();
});

$(window).on('resize', function () {
  ShowTooltip();
});